import { type InjectionKey, inject, type App } from 'vue'
import type { I18nGlobal } from './i18n'

class I18nNotProvidedError extends Error {}

const key = Symbol() as InjectionKey<I18nGlobal>

export function provideI18nGlobal(app: App, i18n: I18nGlobal) {
  app.provide(key, i18n)
}

export function useI18nGlobal() {
  const i18n = inject(key)
  if (i18n === undefined) {
    throw new I18nNotProvidedError('Global i18n was not provided in component tree.')
  }

  return i18n
}
